import { render, staticRenderFns } from "./TableTpl.vue?vue&type=template&id=3b9355b1&scoped=true"
import script from "./TableTpl.vue?vue&type=script&lang=js"
export * from "./TableTpl.vue?vue&type=script&lang=js"
import style0 from "./TableTpl.vue?vue&type=style&index=0&id=3b9355b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9355b1",
  null
  
)

export default component.exports